export default __webpack_public_path__ + "static/media/monumentalui.62e8f4aa.webp";